<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="(showNeuesVerzeichnis = true) && (neu = {})" v-on="on"><v-icon>dns</v-icon></v-btn>
        </template>
        <span>Neues Laufwerk</span>
      </v-tooltip>

      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Suchen"
          single-line
          solo
          flat
          hide-details
          clearable
          clear-icon="close"
        ></v-text-field>
      </v-toolbar-items>
      <v-chip small label color="green" dark>BETA</v-chip>
    </v-toolbar>
    <v-divider></v-divider>

    <v-row no-gutters>
      <v-col cols="3" class="pa-2 pr-0 pl-2">
        <v-card outlined :height="sideHeight">
          <v-treeview dense :items="items" activatable return-object hoverable :active.sync="tree" :item-key="id">
            <template v-slot:label="{ item }">
              <span class="caption">{{ item.name }}</span>
            </template>
            <template v-slot:prepend="{ item, open }">
              <v-icon small v-if="item.icon === 'folder'">
                {{ open ? "mdi-folder-open" : "mdi-folder" }}
              </v-icon>
              <v-icon small v-else>
                {{ item.icon }}
              </v-icon>
            </template>
          </v-treeview>
        </v-card>
      </v-col>

      <v-col :cols="selectFile.id ? 6 : 9" class="py-2 px-2">
        <v-card outlined :height="sideHeight">
          {{ tree2 }}
          <v-card-title>
            <v-icon class="mr-2">{{ tree[0].icon }}</v-icon>
            {{ tree[0].name }}
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="(showNeuerOrdner = true) && (neu = {})" v-on="on"
                  ><v-icon>create_new_folder</v-icon></v-btn
                >
              </template>
              <span>Neuer Ordner</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="(showUploadFiles = true) && (neu = {})" v-on="on"
                  ><v-icon>cloud_upload</v-icon></v-btn
                >
              </template>
              <span>Dateien hochladen</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="downlaodFolder(tree[0])" v-on="on"><v-icon>cloud_download</v-icon></v-btn>
              </template>
              <span>Ordner herunterladen</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="selectFile = tree[0]" v-on="on"><v-icon>info</v-icon></v-btn>
              </template>
              <span>Informationen</span>
            </v-tooltip>
          </v-card-title>
          <v-divider></v-divider>
          <v-simple-table fixed-header height="calc(100vh - 270px)" dense v-if="tree[0].id">
            <thead>
              <tr>
                <th></th>
                <th class="pl-1">Dateiname</th>
                <th>Geändert am</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in getAllChildren(tree[0].id)"
                :key="index"
                @click="item.art === 'Datei' ? (selectFile = item) : ''"
                @dblclick="item.art === 'Ordner' ? (tree[0] = item) : (selectFile = item)"
              >
                <td class="pl-4 pr-1" width="20px">
                  <v-icon class="mr-2">{{ item.icon }}</v-icon>
                </td>
                <td class="pl-1">{{ item.name }}</td>
                <td>{{ $filters.date(item.zuletztbearbeitet, "DD.MM.YYYYhhmm") }} Uhr</td>
                <th width="20px" class="px-1">
                  <v-menu bottom left offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item link>
                        <v-list-item-content
                          ><v-list-item-title @click="item.art === 'Ordner' ? (tree[0] = item) : (selectFile = item)"
                            >Öffnen</v-list-item-title
                          ></v-list-item-content
                        >
                      </v-list-item>
                      <v-list-item link>
                        <v-list-item-title @click="(showRenameFile = true) && (selectFile = item)"
                          >Umbenennen</v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item link>
                        <v-list-item-title @click="(showDeleteFile = true) && (deleteFileData = item)"
                          >Löschen</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </th>
              </tr>
            </tbody>
          </v-simple-table>
          <v-card-text v-else> Bitte wähle ein Verzeichnis aus um die Dateien anzuzeigen. </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="3" class="pa-2 pl-0" v-if="selectFile.id">
        <v-card outlined height="100%">
          <v-card-title class="pb-1">
            <v-spacer></v-spacer>
            <v-btn icon @click="selectFile = {}"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-title class="pb-1 justify-center">
            <span v-if="selectFile.type">
              <span v-if="selectFile.type.includes('image') && selectFile.type !== 'image/svg+xml'">
                <v-img :src="selectFile.url500" max-width="250px" max-height="250px" contain>
                  <template v-slot:placeholder>
                    <v-row class="fill-height grey lighten-3 ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </span>
              <span v-else>
                <v-icon size="64">{{ selectFile.icon }}</v-icon>
              </span>
            </span>
            <span v-else>
              <v-icon size="64">{{ selectFile.icon }}</v-icon>
            </span>
          </v-card-title>
          <v-card-title class="subtitle-2 pt-1">
            <v-spacer></v-spacer>
            {{ selectFile.name }}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-simple-table dense>
            <tbody>
              <tr>
                <td>Zuletzt geändert</td>
                <td class="text-right">
                  {{ $filters.date(selectFile.zuletztbearbeitet, "DD.MM.YYYY") }} <br />{{
                    $filters.date(selectFile.zuletztbearbeitet, "hh:mm")
                  }}
                  Uhr
                </td>
              </tr>
              <tr>
                <td>Geändert von</td>
                <td class="text-right">{{ $filters.user(selectFile.zuletztbearbeitetvon, bbrbbr) }}</td>
              </tr>
              <tr>
                <td>Größe</td>
                <td class="text-right">{{ formatSize(selectFile.size) }}</td>
              </tr>
              <tr>
                <td>Downloads</td>
                <td class="text-right">
                  {{ selectFile.downloadLog.length
                  }}<v-btn icon @click="showDownloadLog = true"><v-icon>info</v-icon></v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-card-actions class="justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="downloadFile(selectFile)" v-on="on"><v-icon>download</v-icon></v-btn>
              </template>
              <span>Herunterladen</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="showRenameFile = true" v-on="on"><v-icon>edit</v-icon></v-btn>
              </template>
              <span>Umbenennen</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="(showDeleteFile = true) && (deleteFileData = selectFile)" v-on="on"
                  ><v-icon>delete</v-icon></v-btn
                >
              </template>
              <span>Löschen</span>
            </v-tooltip>
          </v-card-actions>
          <v-card-actions v-if="showDownloadLog">
            <v-card outlined width="100%">
              <v-card-title class="ma-0 py-0">
                Download-Log
                <v-spacer></v-spacer>
                <v-btn icon @click="showDownloadLog = false"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-simple-table dense>
                <tbody>
                  <tr v-for="(item, index) in selectFile.downloadLog" :key="index">
                    <td>{{ $filters.date(item.date, "DD.M.YY hh:mm") }} Uhr</td>
                    <td>{{ $filters.user(item.contact, bbrbbr) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="showNeuesVerzeichnis"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      width="30%"
      persistent
      scrollable
    >
      <v-card class="pa-0 ma-0">
        <v-card-title>Neues Verzeichnis erstellen</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <v-text-field hide-details outlined dense v-model="neu.name" label="Bezeichnung"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showNeuesVerzeichnis = false">Abbrechen</v-btn>
          <v-btn class="primary" text @click="createVerzeichnis()">Erstellen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showNeuerOrdner" :fullscreen="$vuetify.breakpoint.smAndDown" width="30%" persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-card-title>Neuer Ordner erstellen</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <v-text-field hide-details outlined dense v-model="neu.name" label="Bezeichnung"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showNeuerOrdner = false">Abbrechen</v-btn>
          <v-btn class="primary" text @click="createOrdner()">Erstellen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showUploadFiles" :fullscreen="$vuetify.breakpoint.smAndDown" width="40%" persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-card-title>Dateien hochladen</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <v-file-input
            v-if="!neu.uploadStatus"
            chips
            outlined
            counter
            multiple
            show-size
            v-model="neu.dateien"
            label="Dateien zum hochladen auswählen"
          ></v-file-input>
          <span class="white--text">{{ uploadValue }}</span>
          <span v-if="neu.uploadStatus">
            <span v-for="(item, index) in neu.uploadStatus" :key="index">
              <v-progress-linear :color="item === 100 ? 'green' : 'blue'" :value="item" height="32" rounded
                >{{ neu.dateien[index].name }} ({{ item.toFixed(0) }} %)</v-progress-linear
              >
              <v-progress-linear
                v-if="item < 100"
                class="mt-n1 pb-2"
                color="blue"
                height="4"
                indeterminate
                rounded
              ></v-progress-linear>
            </span>
          </span>
          <v-alert type="warning" v-if="info">{{ info }}</v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="(showUploadFiles = false) && (loading = false)">Abbrechen</v-btn>
          <v-btn class="primary" :loading="loading" text @click="uploadFiles()">Dateien hochladen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showRenameFile" :fullscreen="$vuetify.breakpoint.smAndDown" width="40%" persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-card-title>Datei Umbenennen</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <v-text-field hide-details outlined dense v-model="selectFile.name" label="Bezeichnung"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showRenameFile = false">Abbrechen</v-btn>
          <v-btn class="primary" text @click="renameFile()">Umbenennen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDeleteFile" :fullscreen="$vuetify.breakpoint.smAndDown" width="40%" persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-card-title class="tertiary white--text">Datei löschen</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          Willst du den Ordner <span class="font-weight-bold">{{ deleteFileData.name }}</span> wirklich löschen? Alle
          Unterordener und darin enthaltene Dateien werden unwiederuflich gelöscht. <br /><br />Folgende Ordner und
          Dateien werden gelöscht:
          <span class="mr-1 font-weight-bold" v-for="(item, index) in deleteFileDataAll" :key="index"
            >{{ item.name }}<span v-if="index < deleteFileDataAll.length - 1">, </span></span
          >
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="(showDeleteFile = false) && (loading = false)">Abbrechen</v-btn>
          <v-btn class="tertiary" :loading="loading" text @click="deleteFiles()">Löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        tree2: null,
        search: null,
        tree: [{}],
        selectFile: {},
        test: [],
        showVerzeichnisse: true,
        showNeuesVerzeichnis: false,
        showNeuerOrdner: false,
        showRenameFile: false,
        showUploadFiles: false,
        neu: {
          uploadFiles: [],
          uploadStatus: [],
        },
        loading: false,
        showDeleteFile: false,
        uploadValue: 0,
        deleteFileData: {},
        info: "",
        showDownloadLog: false,
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      sideHeight() {
        this.dateien;
        this.verzeichnisse;
        if (this.$store.state.user.user !== null && this.$store.state.user.user !== undefined) {
          switch (this.$vuetify.breakpoint.name) {
            case "xs":
              return "calc(100vh - 191px)";
            case "sm":
              return "calc(100vh - 179px)";
            case "md":
              return "calc(100vh - 199px)";
            case "lg":
              return "calc(100vh - 191px)";
            case "xl":
              return "calc(100vh - 191px)";
          }
        } else {
          switch (this.$vuetify.breakpoint.name) {
            case "xs":
              return "calc(100vh - 199px)";
            case "sm":
              return "calc(100vh - 199px)";
            case "md":
              return "calc(100vh - 199px)";
            case "lg":
              return "calc(100vh - 199px)";
            case "xl":
              return "calc(100vh - 199px)";
          }
        }
      },
      items() {
        if (this.$store.state.dateien.loaded === false) {
          this.$store.dispatch("dateien/loadDateien");
        }
        let verzeichnisse = [];
        this.$store.state.dateien.dateien.forEach((item) => {
          if (this.search !== null) {
            if (item.name.includes(this.search)) {
              verzeichnisse.push(item);
            }
          } else {
            if (item.art === "Verzeichnis") {
              verzeichnisse.push({
                id: item.id,
                art: item.art,
                name: item.name,
                icon: item.icon,
                children: this.getChildren(item.id),
                size: item.size,
                type: item.type,
                path: item.path,
                url: item.url,
                zuletztbearbeitet: item.zuletztbearbeitet,
                zuletztbearbeitetvon: item.zuletztbearbeitetvon,
              });
            }
          }
        });
        console.log(Array.isArray(verzeichnisse));
        return verzeichnisse;
      },
      deleteFileDataAll() {
        let data = [];
        data.push(this.deleteFileData);
        data = data.concat(this.getFileChilds(this.deleteFileData.id));
        return data;
      },
    },
    methods: {
      getFileChilds(id) {
        let files = [];
        this.$store.state.dateien.dateien.forEach((item) => {
          if (item.parent === id) {
            files.push(item);
            files = files.concat(this.getFileChilds(item.id));
          }
        });
        return files;
      },
      formatSize(bytes) {
        if (bytes >= 1073741824) {
          bytes = (bytes / 1073741824).toFixed(2) + " GB";
        } else if (bytes >= 1048576) {
          bytes = (bytes / 1048576).toFixed(2) + " MB";
        } else if (bytes >= 1024) {
          bytes = (bytes / 1024).toFixed(2) + " KB";
        } else if (bytes > 1) {
          bytes = bytes + " bytes";
        } else if (bytes === 1) {
          bytes = bytes + " byte";
        } else {
          bytes = "";
        }
        return bytes;
      },
      getChildren(id) {
        let children = [];
        this.$store.state.dateien.dateien.forEach((item) => {
          if (item.parent === id && item.art === "Ordner") {
            children.push({
              ...item,
              children: this.getChildren(item.id),
            });
          }
        });
        return children;
      },
      getAllChildren(id) {
        let children = [];
        this.$store.state.dateien.dateien.forEach((item) => {
          if (item.parent === id) {
            children.push({
              ...item,
              children: this.getChildren(item.id),
            });
          }
        });
        return children;
      },
      createVerzeichnis() {
        let neuesVerzeichnis = {
          name: this.neu.name,
          icon: "dns",
          art: "Verzeichnis",
          zuletztbearbeitet: new Date(),
          zuletztbearbeitetvon: this.currentBbr,
        };
        this.$store.dispatch("dateien/createDatei", neuesVerzeichnis);
        this.neu = {};
        this.showNeuesVerzeichnis = false;
      },
      createOrdner() {
        let neuerOrdner = {
          name: this.neu.name,
          icon: "folder",
          art: "Ordner",
          parent: this.tree[0].id,
          zuletztbearbeitet: new Date(),
          zuletztbearbeitetvon: this.currentBbr,
        };
        console.log(neuerOrdner);
        this.$store.dispatch("dateien/createDatei", neuerOrdner);
        this.neu = {};
        this.showNeuerOrdner = false;
      },
      uploadFiles() {
        let id = this.tree[0].id;
        this.loading = true;
        let counter = 0;
        this.neu.uploadStatus = Array(this.neu.dateien.length).fill(0);
        this.neu.dateien.forEach((file) => {
          let name = new Date().getTime() + file.name;
          const storageRef = this.$firebase
            .storage()
            .ref("dateien/" + name)
            .put(file);
          storageRef.on(
            `state_changed`,
            (snapshot) => {
              this.neu.uploadStatus[this.neu.dateien.indexOf(file)] =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            },
            (error) => {
              this.uploadStatus.error = error.message;
            },
            () => {
              storageRef.snapshot.ref.getDownloadURL().then((url) => {
                if (file.type.includes("image") && file.type !== "image/svg+xml") {
                  this.info =
                    "Da Du auch Bilder hochlädst, kann es nach dem Upload noch einige Sekunden dauern bis der Prozess abgeschlossen ist. Bitte schließe das Fenester während des Prozesses nicht";
                  setTimeout(() => {
                    // Get URL for second image
                    let pathParts = storageRef.snapshot.ref.fullPath.split(".");
                    let path200 = `${pathParts.slice(0, -1).join(".")}_200x200.${pathParts.slice(-1)}`;
                    this.$firebase
                      .storage()
                      .ref(path200)
                      .getDownloadURL()
                      .then((url) => {
                        let img2 = url;
                        let path500 = `${pathParts.slice(0, -1).join(".")}_500x500.${pathParts.slice(-1)}`;
                        this.$firebase
                          .storage()
                          .ref(path500)
                          .getDownloadURL()
                          .then((url) => {
                            let img3 = url;
                            let fileData = {
                              name: file.name,
                              size: file.size,
                              type: file.type,
                              path: storageRef.snapshot.ref.fullPath,
                              path200,
                              path500,
                              url: url,
                              url200: img2,
                              url500: img3,
                              icon: "description",
                              art: "Datei",
                              parent: id,
                              zuletztbearbeitet: new Date(file.lastModified),
                              zuletztbearbeitetvon: this.currentBbr,
                            };
                            this.$store.dispatch("dateien/createDatei", fileData);
                            counter++;
                            if (counter === this.neu.dateien.length) {
                              this.neu = {};
                              this.showUploadFiles = false;
                              this.loading = false;
                              this.uploadValue = 0;
                              this.info = "";
                            }
                          })
                          .catch((error) => {
                            console.log(error);
                          });
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  }, 5000);
                } else {
                  let fileData = {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    path: storageRef.snapshot.ref.fullPath,
                    url: url,
                    icon: "description",
                    art: "Datei",
                    parent: id,
                    zuletztbearbeitet: new Date(file.lastModified),
                    zuletztbearbeitetvon: this.currentBbr,
                  };
                  this.$store.dispatch("dateien/createDatei", fileData);
                  counter++;
                  if (counter === this.neu.dateien.length) {
                    this.neu = {};
                    this.showUploadFiles = false;
                    this.loading = false;
                    this.uploadValue = 0;
                  }
                }
              });
            }
          );
        });
      },
      downloadFile(file) {
        var link = document.createElement("a");
        link.setAttribute("href", file.url);
        link.setAttribute("download", file.name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      renameFile() {
        this.$store.dispatch("dateien/updateDateiData", this.selectFile);
        this.showRenameFile = false;
      },
      deleteFiles() {
        this.loading = true;
        console.log(this.deleteFileData);
        console.log(this.deleteFileDataAll);
        this.deleteFileDataAll.forEach((item) => {
          console.log(item);
          if (item.art === "Ordner") {
            this.$store.dispatch("dateien/deleteDateiData", item.id);
          }
          if (item.art === "Datei") {
            if (item.type.includes("image") && item.type !== "image/svg+xml") {
              this.$firebase
                .storage()
                .ref(item.path)
                .delete()
                .catch((error) => console.log("Fehler beim Löschen der Datei: ", error));
              this.$firebase
                .storage()
                .ref(item.path200)
                .delete()
                .catch((error) => console.log("Fehler beim Löschen der Datei: ", error));
              this.$firebase
                .storage()
                .ref(item.path500)
                .delete()
                .then(() => {
                  this.$store.dispatch("dateien/deleteDateiData", item.id);
                })
                .catch((error) => console.log("Fehler beim Löschen der Datei: ", error));
            } else {
              this.$firebase
                .storage()
                .ref(item.path)
                .delete()
                .then(() => {
                  this.$store.dispatch("dateien/deleteDateiData", item.id);
                })
                .catch((error) => console.log("Fehler beim Löschen der Datei: ", error));
            }
          }
        });
        this.loading = false;
        this.showDeleteFile = false;
      },
    },
  };
</script>

<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// dateien.vue?ccbc87da